import Analytics, { AnalyticsInstance } from 'analytics';
// @ts-ignore
import googleAnalyticsPlugin from '@analytics/google-analytics';

let analytics: AnalyticsInstance | null = null;
const initialize = () => {
  if (!analytics) {
    try {
      analytics = Analytics({
        app: 'intake-form',
        debug: true,
        version: 100,
        plugins: [
          googleAnalyticsPlugin({
            measurementIds: [process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID],
          }),
        ],
      });
    } catch (e) {
      console.error(e);
    }
  }
  return analytics;
};

export default initialize;
